import { render, staticRenderFns } from "./PartSearchFacetExtras.vue?vue&type=template&id=564cae38"
import script from "./PartSearchFacetExtras.ts?vue&type=script&lang=ts&external"
export * from "./PartSearchFacetExtras.ts?vue&type=script&lang=ts&external"
import style0 from "./PartSearchFacetExtras.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports